import get from 'lodash/get';
import type {PartVisitor} from 'schemaDefinition/functions/types';
import type {Data, Schema} from 'schemaDefinition/types';
import {visitVisibleSchemaParts} from 'schemaDefinition/functions';

export const getVisiblePartPaths = (
  schema: Schema,
  data: Data,
  relatedScope: Data,
  onlyWithValue: boolean = false,
): string[] => {
  const visiblePartPaths: string[] = [];
  const visitor: PartVisitor = (_part, partPath) => {
    const value = get(data, partPath);
    if (onlyWithValue) {
      if (value) {
        visiblePartPaths.push(partPath);
      }
    } else {
      visiblePartPaths.push(partPath);
    }
  };

  visitVisibleSchemaParts(data, relatedScope, schema, visitor);

  return visiblePartPaths;
};
